<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="name" :name="lodash.upperFirst($t('companies.name'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('companies.name')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            name="name"
            type="text"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.name"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="address" :name="lodash.upperFirst($t('companies.address'))" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('companies.address'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-textarea
            name="address"
            type="text"
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.address"
        ></b-form-textarea>
      </b-form-group>
    </validation-provider>
    <hr>
    <validation-provider vid="description" :name="lodash.upperFirst($t('models.description'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
        class="row mb-3"
        :label="lodash.upperFirst($t('models.description'))"
        :state="errors[0] ? false : (validated ? true : null)"
        :invalid-feedback="errors[0]"
      >
        <editor
          ref="editor"
          v-if="$parent.$parent.$options.name !== 'BModal'"
          class="form-control"
          :init="editorInit"
          inline
          plugins="lists link image paste help wordcount"
          toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
          v-model="model.description"
        />
        <b-form-textarea v-else v-model="model.description" />
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';

  export default {
    extends: FormModel,
    mounted() {
      //
    }
  }
</script>
